module.exports = __webpack_public_path__ + "static/media/ins-ld-bg-tablet.8e79fef1.png";